import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/new-index'
import notice from '@/views/notice.vue'//工告
import tourGL from '@/views/tourStrategy.vue'//景区攻略
import tourZL from '@/views/tourAll.vue'//景区总览
// import tourLX from '@/views/tourLineRoad.vue'//景区路线
import tourKF from '@/views/tourKefu.vue'//客服
import tourHD from '@/views/tourActivity.vue'//景区活动
import tourMessage from '@/views/tourMessage.vue'//景区攻略详情
import zhinan from '@/views/zhinan.vue'//指南
import zhongzhuan from "@/views/zhongzhuan.vue"

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: index
    },
    {
      path: '/notice',
      name: 'notice',
      component: notice
    },
    {
      path: '/tourGL',
      name: 'tourGL',
      component: tourGL
    },{
      path: '/tourZL',
      name: 'tourZL',
      component: tourZL
    },{
      path: '/tourKF',
      name: 'tourKF',
      component: tourKF
    },
    {
      path: '/tourHD',
      name: 'tourHD',
      component: tourHD
    },
    {
      path: '/tourMessage',
      name: 'tourMessage',
      component: tourMessage
    },
    {
      path: '/zhinan',
      name: 'zhinan',
      component: zhinan
    },
    {
      path: '/zhongzhuan',
      name: 'zhongzhuan',
      component: zhongzhuan
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js